import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InventorySparkline } from "../settings/InventorySparkline";
import { InventoryDataPoint, formatInventoryValue } from "./useTenantInventory";

export const TenantInventoryDisplay = ({
  totalInventoryMass,
  formattedDate,
  dataPoints,
}: {
  totalInventoryMass: number;
  formattedDate: string;
  dataPoints: InventoryDataPoint[];
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const color = theme.palette.data.lightblue;

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <InventorySparkline dataPoints={dataPoints} />
      <Stack alignItems="center" justifyContent="center">
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color,
          }}
        >
          {formatInventoryValue(totalInventoryMass)}
          {t("tonnesShort")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ({formattedDate})
        </Typography>
      </Stack>
    </Stack>
  );
};
